import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';

@Component({
  selector: 'app-theam-template-model',
  templateUrl: './theam-template-model.component.html',
  styleUrl: './theam-template-model.component.scss'
})
export class TheamTemplateModelComponent {

  themeTypeForm: UntypedFormGroup;
  @Input() public Content: any;

  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) { }

  ngOnInit() 
  {
    this.themeTypeForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
        BUTTON_BORDER_COLOR: new UntypedFormControl(""),
        BUTTON_HOVER_COLOR: new UntypedFormControl(""),
        BUTTON_TEXT_COLOR: new UntypedFormControl(""),
        HEADER_COLOR: new UntypedFormControl(""),
        LOGIN_BUTTON_COLOR: new UntypedFormControl(""),
        LOGIN_BG_COLOR: new UntypedFormControl(""),
        LOGIN_BUTTON_HOVER: new UntypedFormControl(""),
        LOGIN_BTN_TEXT_COLOR: new UntypedFormControl(""),
        NAV_HOVER_BG: new UntypedFormControl(""),
        RECORD_STATE: new UntypedFormControl(true),
        RecordStatus: new UntypedFormControl(""),
      });
      if (this.Content.heading == "View") 
      {
        this.GetEditData();
        this.themeTypeForm.disable();
      }
      if (this.Content.heading == "Edit") 
      { 
        this.GetEditData();
      }
  }

  GetEditData(): void 
  {
    this.summaryService.getSummaryData('api/themetype/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
     
      this.themeTypeForm.patchValue({
        ID: summary["ID"],
        NAME: summary["NAME"],
        RECORD_STATE: true,
        BUTTON_BORDER_COLOR: summary["BUTTON_BORDER_COLOR"],
        BUTTON_HOVER_COLOR: summary["BUTTON_HOVER_COLOR"],
        BUTTON_TEXT_COLOR: summary["BUTTON_TEXT_COLOR"],
        HEADER_COLOR: summary["HEADER_COLOR"],
        LOGIN_BUTTON_COLOR: summary["LOGIN_BUTTON_COLOR"],
        LOGIN_BG_COLOR: summary["LOGIN_BG_COLOR"],
        LOGIN_BUTTON_HOVER: summary["LOGIN_BUTTON_HOVER"],
        LOGIN_BTN_TEXT_COLOR: summary["LOGIN_BTN_TEXT_COLOR"],
        NAV_HOVER_BG : summary["NAV_HOVER_BG"]
      });
      if (this.Content.heading == "View") 
      {
        this.themeTypeForm.disable();
      }
             
    });

  }

  save() 
  {
    if (this.validateControls()) 
    {
      var formData = this.themeTypeForm.getRawValue();
      formData.NAME=formData.NAME==null?null:formData.NAME==undefined?undefined:formData.NAME.trim();
      formData.RECORD_STATE = this.themeTypeForm.controls["RECORD_STATE"].value ? 1 : 0;
      
      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert('api/themetype/Insert', formData).subscribe(summary => {
          if (summary.Status == 0) {
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
            this.themeTypeForm.controls["ID"].setValue(this.Content.content.id);
          }
          else {
            this.commonservice.ValidationBanner(summary.Message);
          }
        });
      }
      else
      {
        this.summaryService.Insert('api/themetype/Update', formData).subscribe(summary => 
        {
          if (summary.Status == 0)
          {
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
          }
          else 
          {
            this.commonservice.ValidationBanner(summary.Message);
          }
        });
      }
    }
  }

  validateControls(): boolean 
  {
    let isValid = true;
    let message = "";
    const formData = this.themeTypeForm.getRawValue();

    if (formData.NAME === null || formData.NAME === ""||formData.NAME===undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name <br/>";
      isValid = false;
    }else if(formData.NAME !=null&&formData.NAME !=undefined &&formData.NAME.trim()==""){
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name <br/>";
      isValid = false;
    } 
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.BUTTON_BORDER_COLOR === null || formData.BUTTON_BORDER_COLOR === ""||formData.BUTTON_BORDER_COLOR===undefined) {
      $("#BUTTON_BORDER_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#BUTTON_BORDER_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Button Border Color <br/>";
      isValid = false;
    }else if(formData.BUTTON_BORDER_COLOR !=null&&formData.BUTTON_BORDER_COLOR !=undefined &&formData.BUTTON_BORDER_COLOR.trim()==""){
      $("#BUTTON_BORDER_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#BUTTON_BORDER_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Button Border Color <br/>";
      isValid = false;
    } 
    else {
      $("#BUTTON_BORDER_COLOR").addClass("ng-untouched ng-valid");
      $("#BUTTON_BORDER_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.BUTTON_HOVER_COLOR === null || formData.BUTTON_HOVER_COLOR === ""||formData.BUTTON_HOVER_COLOR===undefined) {
      $("#BUTTON_HOVER_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#BUTTON_HOVER_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Button Hover Color <br/>";
      isValid = false;
    }else if(formData.BUTTON_HOVER_COLOR !=null&&formData.BUTTON_HOVER_COLOR !=undefined &&formData.BUTTON_HOVER_COLOR.trim()==""){
      $("#BUTTON_HOVER_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#BUTTON_HOVER_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Button Hover Color <br/>";
      isValid = false;
    } 
    else {
      $("#BUTTON_HOVER_COLOR").addClass("ng-untouched ng-valid");
      $("#BUTTON_HOVER_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.BUTTON_TEXT_COLOR === null || formData.BUTTON_TEXT_COLOR === ""||formData.BUTTON_TEXT_COLOR===undefined) {
      $("#BUTTON_TEXT_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#BUTTON_TEXT_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Button Text Color <br/>";
      isValid = false;
    }else if(formData.BUTTON_TEXT_COLOR !=null&&formData.BUTTON_TEXT_COLOR !=undefined &&formData.BUTTON_TEXT_COLOR.trim()==""){
      $("#BUTTON_TEXT_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#BUTTON_TEXT_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Button Text Color <br/>";
      isValid = false;
    } 
    else {
      $("#BUTTON_TEXT_COLOR").addClass("ng-untouched ng-valid");
      $("#BUTTON_TEXT_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.HEADER_COLOR === null || formData.HEADER_COLOR === ""||formData.HEADER_COLOR===undefined) {
      $("#HEADER_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#HEADER_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Header Color <br/>";
      isValid = false;
    }else if(formData.HEADER_COLOR !=null&&formData.HEADER_COLOR !=undefined &&formData.HEADER_COLOR.trim()==""){
      $("#HEADER_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#HEADER_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Header Color <br/>";
      isValid = false;
    } 
    else {
      $("#HEADER_COLOR").addClass("ng-untouched ng-valid");
      $("#HEADER_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.LOGIN_BUTTON_COLOR === null || formData.LOGIN_BUTTON_COLOR === ""||formData.LOGIN_BUTTON_COLOR===undefined) {
      $("#LOGIN_BUTTON_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BUTTON_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Button Color <br/>";
      isValid = false;
    }else if(formData.LOGIN_BUTTON_COLOR !=null&&formData.LOGIN_BUTTON_COLOR !=undefined &&formData.LOGIN_BUTTON_COLOR.trim()==""){
      $("#LOGIN_BUTTON_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BUTTON_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Button Color <br/>";
      isValid = false;
    } 
    else {
      $("#LOGIN_BUTTON_COLOR").addClass("ng-untouched ng-valid");
      $("#LOGIN_BUTTON_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.LOGIN_BG_COLOR === null || formData.LOGIN_BG_COLOR === ""||formData.LOGIN_BG_COLOR===undefined) {
      $("#LOGIN_BG_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BG_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Background Color <br/>";
      isValid = false;
    }else if(formData.LOGIN_BG_COLOR !=null&&formData.LOGIN_BG_COLOR !=undefined &&formData.LOGIN_BG_COLOR.trim()==""){
      $("#LOGIN_BG_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BG_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Background Color <br/>";
      isValid = false;
    } 
    else {
      $("#LOGIN_BG_COLOR").addClass("ng-untouched ng-valid");
      $("#LOGIN_BG_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.LOGIN_BUTTON_HOVER === null || formData.LOGIN_BUTTON_HOVER === ""||formData.LOGIN_BUTTON_HOVER===undefined) {
      $("#LOGIN_BUTTON_HOVER").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BUTTON_HOVER").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Button Hover Color <br/>";
      isValid = false;
    }else if(formData.LOGIN_BUTTON_HOVER !=null&&formData.LOGIN_BUTTON_HOVER !=undefined &&formData.LOGIN_BUTTON_HOVER.trim()==""){
      $("#LOGIN_BUTTON_HOVER").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BUTTON_HOVER").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Button Hover Color <br/>";
      isValid = false;
    } 
    else {
      $("#LOGIN_BUTTON_HOVER").addClass("ng-untouched ng-valid");
      $("#LOGIN_BUTTON_HOVER").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.LOGIN_BTN_TEXT_COLOR === null || formData.LOGIN_BTN_TEXT_COLOR === ""||formData.LOGIN_BTN_TEXT_COLOR===undefined) {
      $("#LOGIN_BTN_TEXT_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BTN_TEXT_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Button Text Color <br/>";
      isValid = false;
    }else if(formData.LOGIN_BTN_TEXT_COLOR !=null&&formData.LOGIN_BTN_TEXT_COLOR !=undefined &&formData.LOGIN_BTN_TEXT_COLOR.trim()==""){
      $("#LOGIN_BTN_TEXT_COLOR").addClass("ng-touched ng-invalid validate-error");
      $("#LOGIN_BTN_TEXT_COLOR").removeClass("ng-untouched ng-valid");
      message += "Please enter Login Button Text Color <br/>";
      isValid = false;
    } 
    else {
      $("#LOGIN_BTN_TEXT_COLOR").addClass("ng-untouched ng-valid");
      $("#LOGIN_BTN_TEXT_COLOR").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.NAV_HOVER_BG === null || formData.NAV_HOVER_BG === ""||formData.NAV_HOVER_BG===undefined) {
      $("#NAV_HOVER_BG").addClass("ng-touched ng-invalid validate-error");
      $("#NAV_HOVER_BG").removeClass("ng-untouched ng-valid");
      message += "Please enter Navigation Hover Color <br/>";
      isValid = false;
    }else if(formData.NAV_HOVER_BG !=null&&formData.NAV_HOVER_BG !=undefined &&formData.NAV_HOVER_BG.trim()==""){
      $("#NAV_HOVER_BG").addClass("ng-touched ng-invalid validate-error");
      $("#NAV_HOVER_BG").removeClass("ng-untouched ng-valid");
      message += "Please enter Navigation Hover Color <br/>";
      isValid = false;
    } 
    else {
      $("#NAV_HOVER_BG").addClass("ng-untouched ng-valid");
      $("#NAV_HOVER_BG").removeClass("ng-touched ng-invalid validate-error");
    }
    
    
    if (!isValid)
    this.commonservice.ValidationBanner(message);
    return isValid;
  }

}
